import { Link, NavLink, Routes, Route, useNavigate } from "react-router-dom";

import Upload from "./upload";
import Contact from "./contact";
import Login from "./login";
import Configuration from "./Configuration";
import { useGlobalData } from "../components/GlobalDataProvider";
import BuildingWizard from "./BuildingWizard";
import LoggedInWidget from "../components/Global/LoggedInWidget";
import HelpDialog from "../components/Global/Dialogs/HelpDialog";
import AdminSystemTexts from "./AdminSystemTexts";
import Round from "./Round";
import BuildingView from "./BuildingView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBars,
  faBug,
  faBuilding,
  faBuildingFlag,
  faCheck,
  faCircleInfo,
  faCloudArrowUp,
  faCog,
  faCogs,
  faCommentDollar,
  faCross,
  faEnvelope,
  faFeed,
  faFlaskVial,
  faGear,
  faHandshake,
  faHome,
  faHouse,
  faHouseChimney,
  faInfo,
  faInfoCircle,
  faMailBulk,
  faMailReply,
  faMicroscope,
  faReply,
  faRetweet,
  faSignal,
  faSignal5,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import Customers from "./Customers";
import Users from "./Users";
import WelcomeNewUser from "./WelcomeNewUser";
import Register from "./Register";
import UserProfile from "./UserProfile";
import UserChangePassword from "./UserChangePassword";
import UserForgotPassword from "./UserForgotPassword";
import { Container, Image, Nav, Navbar, NavbarBrand, NavDropdown } from "react-bootstrap";
import ChangeAbonnemang from "./ChangeAbonnemang";
import { link } from "fs";
import server from "../modules/server";

import GetStartedDialog from "../components/Global/Dialogs/GetStartedDialog";
import Start from "./Start";
import Test from "./Test";
import { Colors } from "../modules/Colors";
import { CLIENT_VERSION } from "../constants";
import SendBugOrFeedbackDialog from "../components/Global/Dialogs/SendBugOrFeedbackDialog";
import { Font } from "devextreme-react/range-selector";
import ConfirmDialog from "../components/Global/Dialogs/ConfirmDialog";

const LayoutPage = () => {
  const globalData = useGlobalData();
  const navigate = useNavigate();

  const user = globalData.user;

  const hasConfiguration = user?.roles?.Configuration || user?.roles?.Buildings || user?.roles?.Round;
  const isLoggedIn = user ? true : false;

  const navigateToUsers = () => {
    navigate("/Users");
    return false;
  };

  const navigateToCustomers = () => {
    navigate("/Customers");
    return false;
  };

  const navigateToUpload = () => {
    navigate("/upload");
    return false;
  };
  const navigateToSystemText = () => {
    navigate("/systemtexts");
    return false;
  };
  const toggleDebug = () => {
    PubSub.publish("ToggleDebug");
  };
  const toggleDebugBIM = () => {
    PubSub.publish("ToggleDebugBIM");
  };

  const signOut = () => {
    server.logout();
  };

  const switchAccount = (accountId: string) => {
    server.switchAccount(accountId);
  };

  //#efece9
  return (
    <>
      <div style={{ position: "fixed", top: 0, zIndex: 10, left: 0, right: 0, backgroundColor: "white", height: 70 }}></div>
      <Navbar className="m-2 p-1 rounded-3" collapseOnSelect expand="sm" data-bs-theme="dark" bg="dark" variant="dark" style={{ position: "fixed", top: 0, zIndex: 300, left: 0, right: 0 }}>
        <Container fluid className="p-0">
          <NavbarBrand className="ps-2">
            <Nav.Link className="" as={Link} to="/" eventKey={1000}>
              <FontAwesomeIcon icon={faHome} className="me-0" style={{ color: Colors.GreenMedium }} />
              <Image style={{ width: 120 }} src="/logga.svg" />
              {user && (
                <span className="ms-2 d-lg-none">
                  {/* <Image className="me-1" style={{ width: 26, display: globalData.isOnline ? "inline-block" : "none" }} src="/online2.png" title="Uppkopplad" />
                  <Image className="me-1" style={{ width: 26, display: globalData.isOnline ? "none" : "inline-block" }} src="/offline2.png" title="EJ uppkopplad" /> */}

                  {globalData.isOnline ? (
                    <FontAwesomeIcon title="Uppkopplad" icon={faSignal} className="text-success" />
                  ) : (
                    <FontAwesomeIcon icon={faSignal} title="EJ uppkopplad" className="text-danger" />
                  )}
                </span>
              )}
            </Nav.Link>
          </NavbarBrand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav">
            <FontAwesomeIcon icon={faBars} />
          </Navbar.Toggle>

          <Navbar.Collapse className="" id="responsive-navbar-nav">
            <Nav className="flex-grow-1">
              {isLoggedIn && (
                <div role="button" className="nav-link" onClick={() => PubSub.publish("ShowGetStarted")}>
                  <FontAwesomeIcon icon={faInfoCircle} className="me-1" />
                  {<span className={user?.roles.Admin ? "d-lg-inline" : ""}>Kom-igång</span> /* Dölj om admin och size == md */}
                </div>
              )}
              {hasConfiguration && (
                <Nav.Link className="" as={Link} to="/Buildings" eventKey={1}>
                  <FontAwesomeIcon icon={faBuilding} />
                  <span> Byggnader</span>
                </Nav.Link>
              )}
              {isLoggedIn && user?.roles.UserAdmin && (
                <>
                  <NavDropdown
                    className="align-items-center "
                    title={
                      <>
                        <FontAwesomeIcon icon={faCog} />
                        <span> Admin</span>
                      </>
                    }
                  >
                    <NavDropdown.Header>Admin</NavDropdown.Header>
                    <NavDropdown.Divider />
                    <NavDropdown.Item as={Link} className="exact" to="/Users" eventKey={2}>
                      <FontAwesomeIcon icon={faUsers} />
                      <span> Användare</span>
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              )}
              <Nav.Item className="flex-grow-1"></Nav.Item>
              {isLoggedIn && user?.roles.Admin && (
                <NavDropdown
                  className="align-items-center justify-content-end"
                  title={
                    <>
                      <FontAwesomeIcon icon={faGear} />
                      <span className="d-none d-lg-inline"> System</span>
                    </>
                  }
                >
                  <NavDropdown.Header>Systemadmin</NavDropdown.Header>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/Customers" eventKey={3}>
                    <FontAwesomeIcon icon={faBuildingFlag} />
                    <span> Kunder</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/upload" eventKey={4}>
                    <FontAwesomeIcon icon={faCloudArrowUp} />
                    <span> Ladda upp</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/systemtexts" eventKey={5}>
                    <FontAwesomeIcon icon={faCircleInfo} />
                    <span> Systemtexter</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={toggleDebug} active={globalData.isDebug} style={{ textDecoration: globalData.isDebug ? "underline" : "" }}>
                    {globalData.isDebug ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faInfo} />}
                    <span> Debug</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={toggleDebugBIM} active={globalData.isDebugBIM} style={{ textDecoration: globalData.isDebugBIM ? "underline" : "" }}>
                    {globalData.isDebugBIM ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faInfo} />}
                    <span> Debug BIM</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/test" eventKey={8}>
                    <FontAwesomeIcon icon={faFlaskVial} />
                    <span> Test</span>
                  </NavDropdown.Item>
                </NavDropdown>
              )}
              {/* {hasConfiguration && (
                <Nav.Link className="ms-auto" as={Link} to="/Buildings" eventKey={1}>
                  <FontAwesomeIcon icon={faHouseChimney} />
                  <span> Byggnader</span>
                </Nav.Link>
              )} */}
              {/* <LoggedInWidget user={user} /> */}
              {/* //i want to add structure from LoggedInWidget here */}
              {user ? (
                <NavDropdown
                  align="end"
                  className="align-items-center justify-content-end"
                  title={
                    <>
                      <FontAwesomeIcon icon={faUser} />
                      {/* <span> {user.userName}</span> */}
                    </>
                  }
                >
                  <NavDropdown.Header>
                    <span> {user.userName.includes("|") ? user.userName.split("|")[0] : user.userName}</span>
                  </NavDropdown.Header>
                  <NavDropdown.Header>
                    <div>{CLIENT_VERSION}</div>
                  </NavDropdown.Header>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/UserProfile" eventKey={7}>
                    <FontAwesomeIcon icon={faUser} />
                    <span> Min profil</span>
                  </NavDropdown.Item>
                  {isLoggedIn && user?.roles.UserAdmin && (
                    <NavDropdown.Item as={Link} to="/Abonnemang" eventKey={8}>
                      <FontAwesomeIcon icon={faCommentDollar} />
                      <span> Abonnemang</span>
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={signOut} eventKey={9}>
                    <FontAwesomeIcon icon={faArrowRight} />
                    <span> Logga ut</span>
                  </NavDropdown.Item>
                  {user.userAccounts && user.userAccounts.length > 0 && (
                    <>
                      <NavDropdown.Divider />
                      <NavDropdown.Header>
                        <div>Byt till bolag:</div>
                      </NavDropdown.Header>
                      {user.userAccounts.map((account) => (
                        <NavDropdown.Item key={account.id} onClick={() => switchAccount(account.id)} eventKey={10}>
                          <span>{account.customerName}</span>
                          {account.isPrimary && <FontAwesomeIcon icon={faHouse} className="ms-2" title="Primärkonto" />}
                        </NavDropdown.Item>
                      ))}
                    </>
                  )}
                </NavDropdown>
              ) : (
                <>
                  <Nav.Link as={Link} to="/register" eventKey={10}>
                    <FontAwesomeIcon icon={faHandshake} />
                    <span> Registrera</span>
                  </Nav.Link>
                  <Nav.Link as={Link} to="/login" eventKey={11}>
                    <FontAwesomeIcon icon={faUser} />
                    <span> Logga in</span>
                  </Nav.Link>
                </>
              )}
              {isLoggedIn && (
                <div role="button" title="Ge feedback / Rapportera bugg" className="nav-link" style={{ color: Colors.YellowMedium }} onClick={() => PubSub.publish("ShowSendBugOrFeedbackDialog")}>
                  <FontAwesomeIcon icon={faEnvelope} className="me-0" size="lg" />
                  {/* <FontAwesomeIcon icon={faReply} className="me-1 ms-0" />
                  {<span className={user?.roles.Admin ? "d-lg-inline" : ""}></span>} */}
                  {/* Dölj om admin och size == md */}
                </div>
              )}
            </Nav>

            <Nav></Nav>
          </Navbar.Collapse>

          {user && (
            <div className="p-0 ms-2 me-2 d-none d-lg-block">
              {/* <Image className="me-1" style={{ width: 26, display: globalData.isOnline ? "inline-block" : "none" }} src="/online2.png" title="Uppkopplad" />
              <Image className="me-1" style={{ width: 26, display: globalData.isOnline ? "none" : "inline-block" }} src="/offline2.png" title="EJ uppkopplad" /> */}
              {globalData.isOnline ? (
                <FontAwesomeIcon title="Uppkopplad" icon={faSignal} className="text-success" />
              ) : (
                <FontAwesomeIcon icon={faSignal} title="EJ uppkopplad" className="text-danger" />
              )}
            </div>
          )}
        </Container>
      </Navbar>

      <main className="container rounded-2 pb-5 mb-5" style={{ marginTop: 70 }}>
        <HelpDialog />
        <ConfirmDialog />
        <GetStartedDialog />
        <SendBugOrFeedbackDialog />
        <div>
          {/* <Outlet /> */}
          <Routes>
            <Route index element={<Start />} />

            <Route path="WelcomeNewUser" element={<WelcomeNewUser />} />
            {/* <Route path="Dashboard" element={<DashBoard />} /> */}

            {isLoggedIn && (user?.roles.Admin || user?.roles.UserAdmin) && <Route path="Abonnemang" element={<ChangeAbonnemang />} />}

            {isLoggedIn && user?.roles.Admin && <Route path="upload" element={<Upload />} />}

            {isLoggedIn && user?.roles.Admin && <Route path="test" element={<Test />} />}

            {isLoggedIn && user?.roles.Admin && <Route path="systemtexts" element={<AdminSystemTexts />} />}

            {isLoggedIn && user?.roles.Admin && <Route path="Customers" element={<Customers />} />}

            {isLoggedIn && (user?.roles.Admin || user?.roles.UserAdmin) && <Route path="Users" element={<Users />} />}

            {hasConfiguration && <Route path="AddBuildingWizard" element={<BuildingWizard />} />}

            {hasConfiguration && <Route path="Round/*" element={<Round />} />}

            {hasConfiguration && <Route path="Buildings/*" element={<BuildingView />} />}

            {isLoggedIn && <Route path="UserProfile" element={<UserProfile />} />}
            <Route path="login" element={<Login returnTo="/home" />} />
            <Route path="register" element={<Register />} />
            <Route path="ChangePassword" element={<UserChangePassword />} />
            <Route path="UserForgotPassword" element={<UserForgotPassword />} />

            <Route path="*" element={<Start />} />
          </Routes>
        </div>
      </main>
    </>
  );
};

export default LayoutPage;
